import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";


const styles = theme => ({
    // root: {},
});

@withStyles(styles)
class SelectionTab extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    state = {};

    render() {
        const {classes} = this.props;

        return (
            <Typography component="div" style={{padding: 8 * 3}}>
                under construction
            </Typography>
        );
    }
}

export default SelectionTab;